import supabase from '../config/supabaseClient';

export const authService = {
  async signup({ email, password }) {
    try {
      // Try direct signup without email verification
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          // Disable all email operations
          emailRedirectTo: null,
          shouldCreateUser: true,
          data: {
            email,
            email_confirmed_at: new Date().toISOString() // Pre-confirm email
          }
        }
      });
      
      if (error) {
        console.error('Initial signup error:', error);
        throw error;
      }

      // If signup successful but no session, try immediate login
      if (data?.user && !data?.session) {
        const { data: signInData, error: signInError } = await supabase.auth.signInWithPassword({
          email,
          password
        });
        
        if (signInError) throw signInError;
        
        return {
          user: signInData.user,
          session: signInData.session
        };
      }

      return {
        user: data.user,
        session: data.session
      };

    } catch (error) {
      console.error('Signup error:', error);
      throw error;
    }
  },

  async login({ email, password }) {
    console.log('Logging in user:', email);
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    
    if (error) {
      console.error('Login error:', error);
      throw error;
    }
    
    console.log('Login successful:', data);
    return data;
  },

  async forgotPassword(email) {
    console.log('Requesting password reset for:', email);
    const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    
    if (error) {
      console.error('Password reset error:', error);
      throw error;
    }
    
    console.log('Password reset email sent:', data);
    return data;
  },

  async resetPassword(newPassword) {
    const { data, error } = await supabase.auth.updateUser({
      password: newPassword,
    });
    
    if (error) throw error;
    return data;
  },

  async logout() {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
  },

  async getCurrentUser() {
    const { data: { user } } = await supabase.auth.getUser();
    return user;
  }
}; 